const DEMO_ARTIST_ID = 'demo-artist-yumiko-gakudan';
const DEMO_ARTIST_NAME = '楽団 弓子';

const reaction = (type, count, reactedByMe = false) => ({ type, count, reactedByMe });

const baseMessage = ({ id, eventId, content, createdAt, messageFormat = 'text', reactions = [], ...extra }) => ({
  id,
  event_id: eventId,
  thread_id: `demo-thread-${eventId}`,
  content,
  created_at: createdAt,
  message_format: messageFormat,
  is_read: true,
  read_count: 4,
  reactions,
  ...extra,
});

const staffMessage = ({ id, eventId, content, createdAt, admin = 'sato', ...extra }) => {
  const staff = admin === 'takahashi'
    ? { id: 'demo-admin-takahashi', name: '運営担当 高橋', position: '運営担当' }
    : { id: 'demo-admin-sato', name: '制作担当 佐藤', position: '制作担当' };
  return baseMessage({
    id,
    eventId,
    content,
    createdAt,
    message_type: 'admin_message',
    admin_user_id: staff.id,
    admin_full_name: staff.name,
    admin_display_name: staff.name,
    admin_position: staff.position,
    admin_department: 'キャスティカート事務局',
    ...extra,
  });
};

const artistMessage = ({ id, eventId, content, createdAt, mine = false, ...extra }) => baseMessage({
  id,
  eventId,
  content,
  createdAt,
  message_type: 'artist_message',
  artist_id: mine ? DEMO_ARTIST_ID : 'demo-artist-chihiro',
  artist_name: mine ? DEMO_ARTIST_NAME : 'ピアノ 千尋',
  artist_part_label: mine ? 'ヴァイオリン' : 'ピアノ',
  ...extra,
});

const systemMessage = ({ id, eventId, content, createdAt, messageFormat, ...extra }) => baseMessage({
  id,
  eventId,
  content,
  createdAt,
  message_type: 'system_message',
  messageFormat,
  read_count: 0,
  ...extra,
});

function primaryEventMessages(eventId, flyerUrl) {
  return [
    systemMessage({ id: 'demo-ec-001', eventId, content: 'イベント情報が公開されました。', createdAt: '2026-06-24T09:00:00+09:00', messageFormat: 'event_info_published' }),
    staffMessage({ id: 'demo-ec-002', eventId, content: '出演者の皆さま、Casticart デモコンサートのイベントチャットです。本番までの連絡はこちらで共有します。', createdAt: '2026-06-24T09:10:00+09:00' }),
    artistMessage({ id: 'demo-ec-003', eventId, content: 'ピアノの千尋です。皆さま、どうぞよろしくお願いいたします。', createdAt: '2026-06-24T10:05:00+09:00' }),
    artistMessage({ id: 'demo-ec-004', eventId, content: '楽団 弓子です。こちらこそよろしくお願いいたします！', createdAt: '2026-06-24T10:18:00+09:00', mine: true, reactions: [reaction('heart', 2, true)] }),
    staffMessage({ id: 'demo-ec-005', eventId, content: '演奏曲は「愛の挨拶」「タイスの瞑想曲」「情熱大陸」の3曲で進行予定です。曲順のご希望があればお知らせください。', createdAt: '2026-06-25T11:00:00+09:00' }),
    artistMessage({ id: 'demo-ec-006', eventId, content: '曲順はその並びで問題ありません。最後の「情熱大陸」は少し華やかなテンポで演奏できればと思います。', createdAt: '2026-06-25T11:42:00+09:00', mine: true, reactions: [reaction('good', 1)] }),
    artistMessage({ id: 'demo-ec-007', eventId, content: '弓子さん、「愛の挨拶」の伴奏譜は以前共有いただいた版でよいでしょうか？', createdAt: '2026-06-25T12:15:00+09:00' }),
    artistMessage({ id: 'demo-ec-008', eventId, content: 'はい、以前の版でお願いします。念のためリハーサル時にも紙で1部持参します。', createdAt: '2026-06-25T12:33:00+09:00', mine: true, reply_to_message_id: 'demo-ec-007', reply_sender_name: 'ピアノ 千尋', reply_message_format: 'text', reply_preview_text: '伴奏譜は以前共有いただいた版でよいでしょうか？' }),
    staffMessage({ id: 'demo-ec-009', eventId, content: '7月3日のゲネプロは15:00開始、18:00終了予定です。14:45までに舞台袖へお集まりください。', createdAt: '2026-06-26T09:30:00+09:00', admin: 'takahashi', reactions: [reaction('please', 2, true)] }),
    staffMessage({ id: 'demo-ec-010', eventId, content: '会場入口ではなく、建物裏手の「出演者・搬入口」からお入りください。受付でお名前をお伝えいただければご案内します。', createdAt: '2026-06-26T09:36:00+09:00', admin: 'takahashi' }),
    artistMessage({ id: 'demo-ec-011', eventId, content: 'ヴァイオリンと衣装があるためタクシーで伺う予定です。搬入口付近で短時間降車できますか？', createdAt: '2026-06-26T10:02:00+09:00', mine: true }),
    staffMessage({ id: 'demo-ec-012', eventId, content: 'はい、搬入口前で降車できます。車両は常駐できないため、降車後は速やかに移動をお願いします。', createdAt: '2026-06-26T10:20:00+09:00', admin: 'takahashi', reply_to_message_id: 'demo-ec-011', reply_sender_name: DEMO_ARTIST_NAME, reply_message_format: 'text', reply_preview_text: '搬入口付近で短時間降車できますか？', reactions: [reaction('thanks', 1, true)] }),
    artistMessage({ id: 'demo-ec-013', eventId, content: 'ピアノ椅子は背もたれなし、高さ調整できるものを希望します。', createdAt: '2026-06-26T15:05:00+09:00' }),
    staffMessage({ id: 'demo-ec-014', eventId, content: '承知しました。会場備品を確認し、高さ調整式の椅子を舞台へ準備します。', createdAt: '2026-06-26T15:44:00+09:00', admin: 'takahashi', reactions: [reaction('good', 2)] }),
    staffMessage({ id: 'demo-ec-015', eventId, content: '公開中のフライヤー画像です。SNSで告知いただく際はこちらをご利用ください。', createdAt: '2026-06-27T11:00:00+09:00', messageFormat: 'image', image_id: 'demo-event-chat-flyer', image_url: flyerUrl, image_file_name: 'flyer-demo-concert.jpg', image_width: 1080, image_height: 1527, image_expires_at: '2027-07-01T00:00:00+09:00', reactions: [reaction('heart', 3, true)] }),
    artistMessage({ id: 'demo-ec-016', eventId, content: 'ありがとうございます。今夜SNSで告知します。', createdAt: '2026-06-27T11:18:00+09:00', mine: true, reply_to_message_id: 'demo-ec-015', reply_sender_name: '制作担当 佐藤', reply_message_format: 'image', reply_preview_text: '公開中のフライヤー画像です。' }),
    staffMessage({ id: 'demo-ec-017', eventId, content: '衣装は黒を基調に、夏らしい明るい差し色を入れていただければと思います。譜面台は会場で用意します。', createdAt: '2026-06-27T16:25:00+09:00' }),
    artistMessage({ id: 'demo-ec-018', eventId, content: '私はネイビーのドレスを予定しています。舞台照明との相性も問題なさそうでしょうか？', createdAt: '2026-06-27T17:02:00+09:00' }),
    staffMessage({ id: 'demo-ec-019', eventId, content: 'ネイビーで問題ありません。照明担当にも共有しておきます。', createdAt: '2026-06-27T17:30:00+09:00', reactions: [reaction('good', 1, true)] }),
    artistMessage({ id: 'demo-ec-020', eventId, content: '私は黒のロングドレスに、淡いグリーンのアクセサリーを合わせる予定です。', createdAt: '2026-06-27T18:12:00+09:00', mine: true }),
    systemMessage({ id: 'demo-ec-021', eventId, content: '制作担当 佐藤がノートを作成しました。', createdAt: '2026-06-28T09:00:00+09:00', messageFormat: 'note_create', note_id: 'demo-note-day-of-guide', note_title: '本番当日のご案内', note_excerpt: '集合場所、楽屋、リハーサル、本番進行、緊急連絡先をまとめています。', note_image_count: 0 }),
    staffMessage({ id: 'demo-ec-022', eventId, content: 'ノートに当日の進行と緊急連絡先をまとめました。内容をご確認のうえ、不明点があればこのチャットへ返信してください。', createdAt: '2026-06-28T09:08:00+09:00' }),
    artistMessage({ id: 'demo-ec-023', eventId, content: '確認しました。楽屋A、17:00集合で承知しました。', createdAt: '2026-06-28T09:35:00+09:00', mine: true, reactions: [reaction('thanks', 1)] }),
    artistMessage({ id: 'demo-ec-024', eventId, content: '私も確認しました。当日は電子ピアノではなく会場のグランドピアノを使用する認識です。', createdAt: '2026-06-28T10:12:00+09:00' }),
    staffMessage({ id: 'demo-ec-025', eventId, content: 'はい、会場のスタインウェイを使用します。調律は当日13:00に完了予定です。', createdAt: '2026-06-28T10:40:00+09:00', admin: 'takahashi', reactions: [reaction('heart', 1)] }),
    staffMessage({ id: 'demo-ec-026', eventId, content: '当日配布プログラムの校正が上がりました。「楽団 弓子 / ヴァイオリン」の表記で進めます。', createdAt: '2026-06-30T16:05:00+09:00' }),
    artistMessage({ id: 'demo-ec-027', eventId, content: '表記を確認しました。問題ありません。ご準備ありがとうございます。', createdAt: '2026-06-30T16:28:00+09:00', mine: true, reactions: [reaction('thanks', 2, true)] }),
    staffMessage({ id: 'demo-ec-028', eventId, content: '明日の会場下見は14:00開始です。到着されましたら、このイベントチャットへ「到着しました」とお送りください。', createdAt: '2026-07-01T09:15:00+09:00', admin: 'takahashi' }),
    artistMessage({ id: 'demo-ec-029', eventId, content: '承知しました。明日14:00に伺います。よろしくお願いいたします。', createdAt: '2026-07-01T09:42:00+09:00', mine: true, reactions: [reaction('good', 1)] }),
    staffMessage({ id: 'demo-ec-030', eventId, content: '@楽団 弓子 さん、ゲネプロの開始が15分早まり14:45になりました。集合は14:30でお願いします。', createdAt: '2026-07-01T10:30:00+09:00', admin: 'takahashi', is_read: false, reactions: [reaction('please', 1)] }),
  ];
}

function secondaryEventMessages(event) {
  const eventId = event.event_uuid;
  const isFamily = eventId === 'demo-event-family-concert';
  const venue = event.venue_name || event.venue || '会場';
  return [
    staffMessage({ id: `${eventId}-ec-01`, eventId, content: `${event.name}の連絡用チャットです。詳細が決まり次第こちらで共有します。`, createdAt: '2026-06-20T10:00:00+09:00' }),
    artistMessage({ id: `${eventId}-ec-02`, eventId, content: '参加いたしました。どうぞよろしくお願いいたします。', createdAt: '2026-06-20T10:25:00+09:00', mine: true }),
    staffMessage({ id: `${eventId}-ec-03`, eventId, content: `会場は「${venue}」です。出演者受付の場所は開催1週間前までにご案内します。`, createdAt: '2026-06-22T14:00:00+09:00', admin: 'takahashi' }),
    artistMessage({ id: `${eventId}-ec-04`, eventId, content: isFamily ? 'お子さま向けに楽器紹介を入れることは可能でしょうか？' : '演奏スペースの広さと譜面台の有無を教えていただけますか？', createdAt: '2026-06-22T15:10:00+09:00', mine: true }),
    staffMessage({ id: `${eventId}-ec-05`, eventId, content: isFamily ? 'ぜひお願いします。曲間に3分ほど楽器紹介の時間を設けます。' : '演奏スペースは約4m四方です。譜面台と椅子はこちらで準備します。', createdAt: '2026-06-22T16:05:00+09:00', reply_to_message_id: `${eventId}-ec-04`, reply_sender_name: DEMO_ARTIST_NAME, reply_message_format: 'text', reply_preview_text: isFamily ? '楽器紹介を入れることは可能でしょうか？' : '演奏スペースの広さと譜面台の有無を教えていただけますか？', reactions: [reaction('thanks', 1, true)] }),
    staffMessage({ id: `${eventId}-ec-06`, eventId, content: '当日の集合時刻と控室情報をノートにまとめました。ご確認ください。', createdAt: '2026-06-25T11:30:00+09:00' }),
    artistMessage({ id: `${eventId}-ec-07`, eventId, content: '確認しました。移動経路も含めて問題ありません。', createdAt: '2026-06-25T12:00:00+09:00', mine: true, reactions: [reaction('good', 1)] }),
    staffMessage({ id: `${eventId}-ec-08`, eventId, content: 'ありがとうございます。追加の変更がありましたら、このチャットでお知らせします。', createdAt: '2026-06-25T12:20:00+09:00', admin: 'takahashi' }),
  ];
}

export function getArtistDemoEventChatMessages(scenarioId, event, flyerUrl = '') {
  if (!event || scenarioId === 'empty' || scenarioId === 'new-user') return [];
  if (event.event_uuid === 'demo-event-summer-concert') {
    return primaryEventMessages(event.event_uuid, flyerUrl);
  }
  return secondaryEventMessages(event);
}

export function decorateArtistDemoEventChatEvents(scenarioId, events, flyerUrlForEvent) {
  return (Array.isArray(events) ? events : []).map((event, index) => {
    const messages = getArtistDemoEventChatMessages(
      scenarioId,
      event,
      typeof flyerUrlForEvent === 'function' ? flyerUrlForEvent(event.event_uuid) : ''
    );
    const latest = messages[messages.length - 1];
    const unreadCount = messages.length ? (index === 0 ? (scenarioId === 'action-required' ? 4 : 2) : 0) : 0;
    return {
      ...event,
      chat_thread_id: `demo-thread-${event.event_uuid}`,
      chat_mode: 'separate',
      group_event_count: 1,
      last_message_time: latest?.created_at || null,
      last_message_format: latest?.message_format || null,
      last_message_preview: latest?.content || '',
      unread_count: unreadCount,
      unreadCount,
    };
  });
}

export function getArtistDemoEventChatUnreadCounts(scenarioId, events) {
  return decorateArtistDemoEventChatEvents(scenarioId, events)
    .map((event) => ({ event_id: event.event_uuid, unread_count: event.unreadCount || 0 }));
}
